'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var InternalStack = require('../../_chunks/InternalStack-CFsUMwV1.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

/**
 * Use this component to define vertical spacing between elements.
 * https://storybook.templafy.com/?path=/docs/layouts-stack--default-stack#stack
 */
const Stack = react.forwardRef(({ as, ...props }, ref) => (jsxRuntime.jsx(InternalStack.InternalStack, { as: as, ref: ref, ...props })));
Stack.displayName = 'Stack';

exports.Stack = Stack;
//# sourceMappingURL=Stack.js.map
